const KEY = 'nm_landing_seen';
const TTL = 7 * 24 * 60 * 60 * 1000; // 7 days

export function hasSeenSlideshow(): boolean {
  try {
    const ts = localStorage.getItem(KEY);
    if (!ts) return false;
    return Date.now() - Number(ts) < TTL;
  } catch {
    return false;
  }
}

export function markSlideshowSeen(): void {
  try {
    localStorage.setItem(KEY, String(Date.now()));
  } catch {}
}
